module.exports = "<div class=\"content\">\n  <app-header></app-header>\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n<app-mobile-menu *ngIf=\"isMobile\"></app-mobile-menu>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/secure/secure.component.html
// module id = ../../../../../src/app/layouts/secure/secure.component.html
// module chunks = main